(function () {
  if (window.__t4sBlogConnectInit) return;
  window.__t4sBlogConnectInit = true;

  var COPY = {
    heading: 'Leave a comment',
    notesHtml:
      'Your email address will not be published. Required fields are marked <span class="required">*</span>',
    warning: 'Please note, comments must be approved before they are published',
    submit: 'Post Comment'
  };

  function enhanceForm(form) {
    if (!form) return;

    if (!form.querySelector('.t4s-bc-form-heading')) {
      var heading = document.createElement('h2');
      heading.className = 't4s-bc-form-heading';
      heading.textContent = COPY.heading;
      form.insertBefore(heading, form.firstChild);

      var notes = document.createElement('p');
      notes.className = 't4s-bc-form-notes';
      notes.innerHTML = COPY.notesHtml;
      form.insertBefore(notes, heading.nextSibling);
    }

    form.querySelectorAll('.br-field > label').forEach(function (label) {
      if (label.querySelector('.t4s-bc-req')) return;
      var star = document.createElement('span');
      star.className = 't4s-bc-req';
      star.setAttribute('aria-hidden', 'true');
      star.textContent = ' *';
      label.appendChild(star);
    });

    form.querySelectorAll('.br-input, .br-textarea').forEach(function (el) {
      el.setAttribute('placeholder', '');
    });

    var submit = form.querySelector('.br-submit');
    if (submit && submit.textContent.trim() !== COPY.submit) {
      submit.textContent = COPY.submit;
    }

    if (!form.querySelector('.t4s-bc-form-warning')) {
      var actions = form.querySelector('.br-actions');
      var warning = document.createElement('p');
      warning.className = 't4s-bc-form-warning t4s-fnt-fm-3';
      warning.textContent = COPY.warning;
      if (actions) form.insertBefore(warning, actions);
      else form.appendChild(warning);
    }

    form.dataset.t4sStyled = '1';
  }

  function hideNativeForm() {
    var nativeForm = document.getElementById('CommentForm');
    if (!nativeForm) return;
    nativeForm.style.display = 'none';
    var prev = nativeForm.previousElementSibling;
    if (prev && prev.classList.contains('t4s-line-space')) prev.style.display = 'none';
    var block = nativeForm.closest('.t4s-article-comments-block');
    if (block) {
      block.querySelectorAll('.t4s-comments-form__heading, .t4s-comments-form__notes').forEach(function (el) {
        el.style.display = 'none';
      });
    }
  }

  function styleWidths() {
    var wrapper = document.getElementById('blogconnect-wrapper');
    if (wrapper) {
      wrapper.style.display = 'block';
      wrapper.style.setProperty('width', '100%', 'important');
      wrapper.style.setProperty('max-width', '100%', 'important');
    }
    var root = document.querySelector('.blog-reply-app-root.blog_connect_comment_section');
    if (root) {
      root.style.setProperty('width', '100%', 'important');
      root.style.setProperty('max-width', '100%', 'important');
    }
    var form = document.getElementById('blog-reply-form');
    if (form) {
      form.style.setProperty('width', '100%', 'important');
      form.style.setProperty('max-width', '100%', 'important');
    }
  }

  function run() {
    var form = document.getElementById('blog-reply-form');
    if (!form) return false;
    hideNativeForm();
    enhanceForm(form);
    styleWidths();
    return true;
  }

  run();
  document.addEventListener('DOMContentLoaded', run);

  var tries = 0;
  var timer = setInterval(function () {
    tries += 1;
    run();
    if (tries > 60) clearInterval(timer);
  }, 250);

  var obsTimer = null;
  var obs = new MutationObserver(function () {
    clearTimeout(obsTimer);
    obsTimer = setTimeout(run, 50);
  });

  function startObs() {
    if (!document.body) return;
    obs.observe(document.body, { childList: true, subtree: true });
  }

  if (document.body) startObs();
  else document.addEventListener('DOMContentLoaded', startObs);
})();
